<!-- リンクボタン -->
<template>
  <div class="home_cat_buttons1">
    <template v-for="button in iconMenuListData" :key="button.menuId">
      <a
        v-if="button.linkURL.startsWith('http')"
        :href="button.linkURL"
        :target="button.isSaparateTab ? '_blank' : '_self'"
        :class="['button1', { hover: button.hover }]"
        @mouseover="button.hover = true"
        @mouseleave="button.hover = false"
      >
        <span
          :class="['image1', button.hover ? 'hover' : '']"
          :style="{
            backgroundImage: `url(${appDir}/images/${
              button.hover ? button.imageFileOver : button.imageFileNomal
            })`,
            backgroundColor: '#F3F5F9',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            transition: '0.5s ease',
            transform: button.hover ? 'scale(1.05)' : 'scale(1)',
          }"
        ></span>
        <span class="text1">{{ button.menuName }}</span>
      </a>

      <router-link
        v-else
        :to="button.linkURL"
        :key="button.menuId"
        :target="button.isSaparateTab ? '_blank' : '_self'"
        :class="['button1', { hover: button.hover }]"
        @mouseover="button.hover = true"
        @mouseleave="button.hover = false"
      >
        <span
          :class="['image1', button.hover ? 'hover' : '']"
          :style="{
            backgroundImage: `url(${appDir}/images/${
              button.hover ? button.imageFileOver : button.imageFileNomal
            })`,
            backgroundColor: '#F3F5F9', // 背景色
            backgroundPosition: 'center', // 画像を中央に配置
            backgroundSize: 'cover', // 画像をカバーとして設定
            transition: '0.5s ease',
            transform: button.hover ? 'scale(1.05)' : 'scale(1)', // ホバー時にスケールを変更
          }"
        ></span>
        <span class="text1">{{ button.menuName }}</span>
      </router-link>
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs, formatMessage } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";

interface Item {
  menuId: string;
  menuName: string;
  imageFileNomal: string;
  imageFileOver: string;
  linkURL: string;
  hover: boolean;
  isSaparateTab: boolean;
}

export default defineComponent({
  name: "IconMenuComponent",
  setup() {
    const isHover = ref(false);
    const iconMenuListData = ref<Item[]>([]);
    const agCode = ref<string | null>(null);
    const userId = ref<string | null>(null);
    const appDir = process.env.VUE_APP_DIR;

    onMounted(async () => {
      try {
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          // 最初に疑似ログインAGコードとユーザーIDを検索用の変数にセット
          agCode.value = parsedUserInfo.pseudoAgCode;
          userId.value = parsedUserInfo.pseudoUserId;

          // 疑似ログインAGコードが入っていなかった場合は、ログインしているAGコードとユーザーID
          if (agCode.value === null || agCode.value === "") {
            agCode.value = parsedUserInfo.agCode;
            userId.value = parsedUserInfo.userId;
          }
        }

        outputDebugLogs("アイコンメニュー取得");

        // アイコンメニュー取得API
        const response = await apiAuthClient.post(
          "/api/IconMenu/getIconMenuyList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
          }
        );
        iconMenuListData.value = response.data.iconMenuListData;
        outputDebugLogs(
          "アイコンメニュー取得成功 件数：" + iconMenuListData.value.length
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(
          formatMessage(messages.ERR_SYS003, "アイコンメニューデータの取得")
        );
      } finally {
        //何か入れるかも
      }
    });
    return {
      iconMenuListData,
      isHover,
      appDir,
    };
  },
});
</script>
